module.exports = {
  footerText: 'Copyright Aadesh Cabs © 2023',
}
